import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  loaded: false,
  packages: { type: [], size: [], status: [], deliveryEndorsementType: [] },
  roles: [],
  countries: [],
  deliveryTerm: [],
  userType: [],
  cities: [],
  dispatchTypes: [],
  vehicleTypes: [],
  notifierType: [],
  daysService: [],
  currentServices: [],
};

const globalsSlice = createSlice({
  name: 'globals',
  initialState,
  reducers: {
    fetch: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.loaded = true;
      state.packages = action.payload.packages;
      state.countries = action.payload.countries;
      state.roles = action.payload.roles;
      state.deliveryTerm = action.payload.deliveryTerm;
      state.userType = action.payload.userType;
      state.cities = action.payload.cities;
      state.dispatchTypes = action.payload.dispatchTypes;
      state.notifierType = action.payload.notifierType;
      state.daysService = action.payload.daysService;
      state.currentServices = action.payload.currentServices;
      state.vehicleTypes = action.payload.vehicleTypes;
    },
    failure: (state) => {
      state.loaded = true;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, actions, reducer } = globalsSlice;
